import React from 'react';

interface ModernMousePointerProps {
  size?: number;
  color?: string;
  className?: string;
}

const ModernMousePointer: React.FC<ModernMousePointerProps> = ({
  size = 24,
  color = '#ffffff',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3 3L10.5 21L13.5 13.5L21 10.5L3 3Z"
        fill={color}
        stroke="rgba(0,0,0,0.3)"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default ModernMousePointer;
